export default "__VITE_ASSET__Btyc1bCS__"